import React, { useState, useEffect } from 'react';
import { bateau as bateauAPI } from '../api';
import './NavigationChoiceModal.css';

function NavigationChoiceModal({ show, onClose, onStartCroisiere, onStartNavigationJournee }) {
  const [step, setStep] = useState('choice'); // 'choice', 'croisiere-form', 'journee-form', 'bateau-select'
  const [bateaux, setBateaux] = useState([]);
  const [selectedBateau, setSelectedBateau] = useState(null);
  
  // Croisière
  const [nomCroisiere, setNomCroisiere] = useState('');
  const [description, setDescription] = useState('');
  const [destinationCroisiere, setDestinationCroisiere] = useState('');
  
  // Navigation journée
  const [destinationJournee, setDestinationJournee] = useState('');

  useEffect(() => {
    if (show) {
      loadBateaux();
    }
  }, [show]);

  const loadBateaux = async () => {
    try {
      const response = await bateauAPI.getAll();
      setBateaux(response.data);
      
      if (response.data.length === 1) {
        setSelectedBateau(response.data[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const resetForm = () => {
    setStep('choice');
    setNomCroisiere('');
    setDescription('');
    setDestinationCroisiere('');
    setDestinationJournee('');
    setSelectedBateau(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleCroisiereClick = () => {
    setStep('croisiere-form');
  };

  const handleJourneeClick = () => {
    setStep('journee-form');
  };

  const handleCroisiereFormSubmit = (e) => {
    e.preventDefault();
    if (!nomCroisiere || !destinationCroisiere) {
      alert('Le nom de la croisière et la destination du jour sont requis');
      return;
    }
    
    if (bateaux.length === 0) {
      alert('Vous devez d\'abord créer un bateau');
      // Rediriger vers création bateau
      return;
    }
    
    if (bateaux.length > 1 && !selectedBateau) {
      setStep('bateau-select');
      return;
    }
    
    const bateau = selectedBateau || bateaux[0];
    onStartCroisiere(bateau.id, nomCroisiere, description, destinationCroisiere);
    resetForm();
  };

  const handleJourneeFormSubmit = (e) => {
    e.preventDefault();
    if (!destinationJournee) {
      alert('La destination est requise');
      return;
    }
    
    if (bateaux.length === 0) {
      alert('Vous devez d\'abord créer un bateau');
      return;
    }
    
    if (bateaux.length > 1 && !selectedBateau) {
      setStep('bateau-select');
      return;
    }
    
    const bateau = selectedBateau || bateaux[0];
    onStartNavigationJournee(bateau.id, destinationJournee);
    resetForm();
  };

  const handleBateauSelect = (bateau) => {
    setSelectedBateau(bateau);
    
    if (step === 'bateau-select') {
      if (nomCroisiere) {
        onStartCroisiere(bateau.id, nomCroisiere, description, destinationCroisiere);
      } else {
        onStartNavigationJournee(bateau.id, destinationJournee);
      }
      resetForm();
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content nav-choice-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🧭 Démarrer une sortie</h2>
          <button onClick={handleClose} className="close-btn">✕</button>
        </div>

        <div className="modal-body">
          {/* ÉTAPE 1 : CHOIX CROISIÈRE OU JOURNÉE */}
          {step === 'choice' && (
            <div className="nav-choices">
              <div className="choice-card" onClick={handleCroisiereClick}>
                <div className="choice-icon">🚢</div>
                <h3>Nouvelle Croisière</h3>
                <p>Plusieurs jours avec navigation multiple</p>
                <ul className="choice-features">
                  <li>✅ Plusieurs navigations regroupées</li>
                  <li>📄 1 PDF complet à la fin</li>
                  <li>📧 Envoi par email</li>
                </ul>
              </div>

              <div className="choice-card" onClick={handleJourneeClick}>
                <div className="choice-icon">⛵</div>
                <h3>Navigation Journée</h3>
                <p>Sortie unique d'une journée</p>
                <ul className="choice-features">
                  <li>✅ Navigation simple</li>
                  <li>📄 1 PDF à la fin</li>
                  <li>💾 Sauvegarde automatique</li>
                </ul>
              </div>
            </div>
          )}

          {/* ÉTAPE 2A : FORMULAIRE CROISIÈRE */}
          {step === 'croisiere-form' && (
            <form onSubmit={handleCroisiereFormSubmit} className="croisiere-form">
              <h3>📝 Informations de la croisière</h3>
              
              <div className="form-group">
                <label>Nom de la croisière *</label>
                <input
                  type="text"
                  value={nomCroisiere}
                  onChange={(e) => setNomCroisiere(e.target.value)}
                  placeholder="Ex: Croisière Méditerranée 2026"
                  className="form-input"
                  autoFocus
                  required
                />
              </div>

              <div className="form-group">
                <label>Description (optionnelle)</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Itinéraire prévu, escales..."
                  className="form-textarea"
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Destination du jour *</label>
                <input
                  type="text"
                  value={destinationCroisiere}
                  onChange={(e) => setDestinationCroisiere(e.target.value)}
                  placeholder="Ex: Port de Nieuport"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-actions">
                <button type="button" onClick={() => setStep('choice')} className="btn btn-secondary">
                  ← Retour
                </button>
                <button type="submit" className="btn btn-primary">
                  {bateaux.length > 1 ? 'Suivant →' : '🚀 Démarrer'}
                </button>
              </div>
            </form>
          )}

          {/* ÉTAPE 2B : FORMULAIRE NAVIGATION JOURNÉE */}
          {step === 'journee-form' && (
            <form onSubmit={handleJourneeFormSubmit} className="croisiere-form">
              <h3>⛵ Navigation du jour</h3>
              
              <div className="form-group">
                <label>Destination *</label>
                <input
                  type="text"
                  value={destinationJournee}
                  onChange={(e) => setDestinationJournee(e.target.value)}
                  placeholder="Ex: Port de Nieuport"
                  className="form-input"
                  autoFocus
                  required
                />
              </div>

              <div className="form-actions">
                <button type="button" onClick={() => setStep('choice')} className="btn btn-secondary">
                  ← Retour
                </button>
                <button type="submit" className="btn btn-primary">
                  {bateaux.length > 1 ? 'Suivant →' : '🚀 Démarrer'}
                </button>
              </div>
            </form>
          )}

          {/* ÉTAPE 3 : SÉLECTION BATEAU */}
          {step === 'bateau-select' && (
            <div className="bateau-select">
              <h3>🛥️ Sélectionnez un bateau</h3>
              <div className="bateau-list">
                {bateaux.map(b => (
                  <div 
                    key={b.id} 
                    className="bateau-card"
                    onClick={() => handleBateauSelect(b)}
                  >
                    <h4>{b.nom}</h4>
                    <p>
                      {b.type === 'voilier' && '⛵ Voilier'}
                      {b.type === 'moteur' && '🚤 Moteur'}
                      {b.type === 'catamaran' && '⛵ Catamaran'}
                    </p>
                  </div>
                ))}
              </div>
              <button 
                type="button" 
                onClick={() => setStep(nomCroisiere ? 'croisiere-form' : 'journee-form')} 
                className="btn btn-secondary"
                style={{ marginTop: '20px' }}
              >
                ← Retour
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NavigationChoiceModal;